import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { useActions, useFetching } from '@mssgme/hooks';
import { Input, Button } from '@mssgme/ui';
import { useDomain } from './hooks';
import DomainLayout from './DomainLayout';
import Help from './Help';

export default function DomainDisconnect() {
    const { t } = useTranslation('cards');
    const actions = useActions();
    const domain = useDomain();
    const domainDisconnect = useFetching(actions.card.domain.disconnect);

    if (domainDisconnect.fulfilled) {
        return <Redirect to="/p/settings/domain" />;
    }

    return (
        <DomainLayout>
            <Input value={domain.name} disabled />
            <Help>
                <p>{t('domain.resolved')}</p>
            </Help>
            <p>
                <Button btnStyle="danger" fullWidth onClick={() => domainDisconnect.run()}>
                    {t('domain.disconnect')}
                </Button>
            </p>
        </DomainLayout>
    );
}
